require('./bootstrap');

import Vue from 'vue';

import '../../app/Modules/ProvidentFund/resources';
import '../../app/Modules/GratuityFund/resources'; // Rejwan: gf_unified


window.addEventListener( "pageshow", function ( event ) {
  var historyTraversal = event.persisted || 
                         ( typeof window.performance != "undefined" && 
                              window.performance.navigation.type === 2 );
  if ( historyTraversal ) {
    // Handle page restore.
    window.location.reload();
  }
}); 
 

var hostname = window.location.hostname;
var protocol = window.location.protocol;
Vue.prototype.$api_url = protocol + "//" + hostname;

Vue.prototype.$api_url_front =  window.location.origin+"/front"; // Start: Rejwan pf_unified: 08-02-2026 Front Routes

Vue.prototype.$fiscal_years = [];
Vue.prototype.$fiscal_year_options = [];
Vue.prototype.$years = [];
Vue.prototype.$atl_company_number_format = '';


import { Encrypter } from 'laravel-crypton';

const key_tmp = process.env.MIX_CUSTOM_ENCRYPTION_KEY;
const key = key_tmp.split(':')[1];
const crypt = new Encrypter(key);
if(mozilla != '')
  Vue.prototype.$acl = crypt.decrypt(mozilla);



let currentYear = new Date().getFullYear();
let year_options = Array.from({ length: 6 }, (_, i) => currentYear - i);
let month_options = Array.from({ length: 12 }, (_, i) => {
    const value = ('0' + (i + 1)).slice(-2);
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return {
        value: value,
        text: monthNames[i]
    };
});

Vue.prototype.$year_options = year_options;
Vue.prototype.$month_options = month_options;

Vue.prototype.$modules = {1:'Expense' , 2:'GF Run' , 3:'GF Settlement' , 4:'Leave' , 5:'Loan' , 6:'Payrun' , 7:'PF Loan' , 8:'PF Investment' , 9:'PF Settlement', 10: 'Gratuity Fund', 11: 'Gratuity Fund Investment'}; // Rejwan: gf_unified
Vue.prototype.$months = {1:'January' , 2:'February' , 3:'March' , 4:'April' , 5:'May' , 6:'June' , 7:'July' , 8:'August' , 9:'September', 10:'October', 11:'November', 12:'December'};


import VeeValidate from 'vee-validate';
// Start: Rejwan: 18-05-2026 pf_unified
import { Validator } from 'vee-validate';
Validator.extend('after_or_equal', {
    validate: (value, [target]) => {
        if (!value || !target) return true;
        return new Date(value) >= new Date(target);
    },
    getMessage: (field, [target]) => `The ${field} must be on or after ${target}.`
});
// End: Rejwan: 18-05-2026 pf_unified


if(atl_company_package_title != '')
{
  Vue.prototype.$atl_company_package_title = atl_company_package_title;
}
else
{
  Vue.prototype.$atl_company_package_title = '';
}
  


Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields',
  errorBagName: 'veeErrors'
});

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';


Vue.use(BootstrapVue , {
  "BToast" : {"toaster" : 'b-toaster-bottom-left'}
});
Vue.use(IconsPlugin);
 

import VueSidebarMenu from 'vue-sidebar-menu';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
Vue.use(VueSidebarMenu);


import ToggleButton from 'vue-js-toggle-button'; 
Vue.use(ToggleButton);

import VCalendar from 'v-calendar';
Vue.use(VCalendar);

var moment = require('moment');
Vue.use(moment);

import CKEditor from 'ckeditor4-vue';
Vue.use( CKEditor );


import VueApexCharts from 'vue-apexcharts'; // Rejwan: pf_unified - 13-05-2026
Vue.use(VueApexCharts); // Rejwan: pf_unified - 13-05-2026
Vue.component('apexchart', VueApexCharts); // Rejwan: pf_unified - 13-05-2026

Vue.component('test-post', require('./components/TestPost.vue').default);
Vue.component('test-get', require('./components/TestGet.vue').default);

Vue.component('all-templates', require('./components/AllTemplates.vue').default);

Vue.component('left-panel', require('./components/LeftPanel.vue').default);

Vue.component('admins', require('./components/Admins.vue').default);
Vue.component('admin-users', require('./components/AdminUsers.vue').default);
Vue.component('login', require('./components/Login.vue').default);
Vue.component('admin-register', require('./components/AdminRegister.vue').default);
Vue.component('set-password', require('./components/SetPassword.vue').default); // 31st aug 2021

Vue.component('admin-usersettings', require('./components/AdminUserSettings.vue').default);

Vue.component('system-team-allocation', require('./components/SystemTeamAllocation.vue').default); // fars new 31st jan 2023

Vue.component('system-message', require('./components/SystemMessage.vue').default);
Vue.component('show-system-message', require('./components/ShowSystemMessages.vue').default);

Vue.component('all-agents', require('./components/AllAgents.vue').default);
Vue.component('users-agents', require('./components/UsersAgents.vue').default);
Vue.component('agent-team-allocation', require('./components/AgentTeamAllocation.vue').default); // new 23rd sept 2021

Vue.component('edit-agent', require('./components/EditAgent.vue').default);

Vue.component('company-wizerd', require('./components/CompanyWizard.vue').default); 
Vue.component('company-info', require('./components/CompanyInfo.vue').default); 
Vue.component('company-public-info', require('./components/CompanyPublicInfo.vue').default); 
Vue.component('company-dashboard', require('./components/CompanyDashboard.vue').default); 

Vue.component('company-users', require('./components/CompanyUsers.vue').default);

Vue.component('company-overview', require('./components/CompanyOverview.vue').default); 
Vue.component('company-taxinfo', require('./components/CompanyTaxInfo.vue').default); 

Vue.component('all-departments', require('./components/AllDepartments.vue').default);  // 26th aug 2021
Vue.component('all-jobpositions', require('./components/AllJobpositions.vue').default);  // 26th aug 2021
Vue.component('all-branches', require('./components/AllBranches.vue').default);  // 26th aug 2021


Vue.component('all-geolocations', require('./components/AllGeoLocations.vue').default);  // 14th jan 2024

Vue.component('map-geolocations', require('./components/MapGeoLocations.vue').default);  // 14th jan 2024

Vue.component('employee-geo-ocations', require('./components/EmployeeGeoLocations.vue').default);// 07 FEB 2024



Vue.component('company-signatory', require('./components/AllSignatories.vue').default); // 17th july 2021 
Vue.component('employee-profile-signatory-front', require('./components/front/EmployeeSignature.vue').default); // 1st november 2023 

Vue.component('all-company', require('./components/AllCompanies.vue').default);
Vue.component('info-company', require('./components/InfoCompany.vue').default); 


Vue.component('all-banks', require('./components/Banks.vue').default);  // new 14th May 2024

Vue.component('all-employees', require('./components/AllEmployees.vue').default); 
Vue.component('company-directory', require('./components/CompanyDirectory.vue').default); 
Vue.component('company-directory-front', require('./components/front/CompanyDirectory.vue').default);
Vue.component('all-employees-widget', require('./components/AllEmployeesWidget.vue').default); 
Vue.component('search-employees', require('./components/SearchEmployees.vue').default); 

Vue.component('search-employees-front', require('./components/front/SearchEmployees.vue').default); // new 30th july 2024

Vue.component('employee-wizerd', require('./components/EmployeeWizard.vue').default); 
Vue.component('employee-previous-next', require('./components/EmployeePreviousNext.vue').default); // new 25th sept 2021
Vue.component('account-employees', require('./components/AccountEmployees.vue').default); 
Vue.component('employee-public-info', require('./components/EmployeePublicInfo.vue').default); 
Vue.component('employee-public-info-front', require('./components/front/EmployeePublicInfo.vue').default); 
Vue.component('employee-bank-info', require('./components/EmployeeBankInfo').default);
Vue.component('employee-bank-info-front', require('./components/front/EmployeeBankInfo').default);
Vue.component('employee-nominee-info', require('./components/EmployeeNomineeInfo').default);
Vue.component('employee-nominee-info-front', require('./components/front/EmployeeNomineeInfo').default);

Vue.component('employee-signature', require('./components/EmployeeSignature.vue').default); // new 17th march 2022

Vue.component('employee-investment-info', require('./components/EmployeeInvestmentInfo.vue').default);
Vue.component('employee-investment-info-front', require('./components/front/EmployeeInvestmentInfo.vue').default);
Vue.component('employee-ait-info', require('./components/EmployeeAitInfo.vue').default);
Vue.component('employee-ait-info-front', require('./components/front/EmployeeAitInfo.vue').default);
Vue.component('employee-rfc-info', require('./components/EmployeeRfcInfo.vue').default);
Vue.component('employee-rfc-info-front', require('./components/front/EmployeeRfcInfo.vue').default);
Vue.component('employee-mph-info', require('./components/EmployeeMphInfo.vue').default);
Vue.component('employee-mph-info-front', require('./components/front/EmployeeMphInfo.vue').default);

Vue.component('employee-documents', require('./components/EmployeeDocuments.vue').default);
Vue.component('employee-documents-front', require('./components/front/EmployeeDocuments.vue').default); // new 7th march 2022

Vue.component('request-docements', require('./components/RequestDocuments.vue').default); // new 9th march 2022

Vue.component('employees-import', require('./components/EmployeesImport.vue').default);
Vue.component('employees-data-import', require('./components/EmployeesDataImport.vue').default); // new 14th sept 2021
Vue.component('employees-investment-import', require('./components/EmployeesInvestmentImport.vue').default);
Vue.component('search-employee', require('./components/SearchEmployee.vue').default);  // aug 21 2021
Vue.component('employee-portal', require('./components/EmployeePortal').default);
Vue.component('account-employees-portal', require('./components/AccountEmployeesPortal').default);
Vue.component('emp-company-list-menu', require('./components/EmpCompanyListMenu').default); // fars new 4th may 2021
Vue.component('emp-company-list-menu-new', require('./components/front/EmpCompanyListMenuNew').default); // fars new 4th may 2021 
Vue.component('emp-dropdown-info', require('./components/EmpDropdownInfo').default); // fars new 4th may 2021
Vue.component('employee-settings', require('./components/EmployeeSettings').default); // fars new 4th may 2021

Vue.component('employee-payment-bank-info', require('./components/EmployeePaymentBankInfo.vue').default); // Sohel new 9th january 2025
Vue.component('employees-bank-payment-import', require('./components/EmployeesBankPaymentImport.vue').default); // Rejwan: 26-01-2025
Vue.component('payment-account-settings', require('./components/PaymentAccountSettings.vue').default); //payment settings
//Vue.component('employee-leave-attendance-wrapper-front', require('./components/front/EmployeeLeaveAttendanceWrapperFront.vue').default);  // fars new 4th may 2021

Vue.component('employees-personal-tax-file-import', require('./components/EmployeesPersonalTaxFileImport.vue').default); // import personal tax file bulk
Vue.component('employees-personal-tax-file-data-import', require('./components/EmployeesPersonalTaxFileDataImport.vue').default); // import personal tax file bulk

Vue.component('employees-cost-center-import', require('./components/EmployeesCostCenterImport.vue').default); // Sohel: New mappings update


/*
Vue.component('apply-leave', require('./components/front/ApplyLeave.vue').default);  // fars new 25th june 2021

Vue.component('employee-front', require('./components/front/EmployeeFront').default); // fars new 4th may 2021
Vue.component('employee-dashboard', require('./components/front/EmployeeDashboard').default); // fars new 4th june 2021
Vue.component('employee-info', require('./components/front/EmployeeInfo.vue').default); // fars new 4th june 2021
Vue.component('subordinate-list', require('./components/SubordinateList').default); // fars new 13th may 2021
Vue.component('subordinate', require('./components/Subordinate').default); // fars new 13th may 2021



Vue.component('government-holidays', require('./components/GovernmentHolidays.vue').default);

Vue.component('leaveattendances-dashboard', require('./components/LeaveAttendanceDashboard.vue').default);
Vue.component('leave-settings', require('./components/LeaveSettings.vue').default);
Vue.component('employee-leave-settings', require('./components/EmployeeLeaveAttendance.vue').default);

Vue.component('employee-leave-attendance-wrapper', require('./components/EmployeeLeaveAttendanceWrapper.vue').default);
Vue.component('employee-leave', require('./components/EmployeeLeave.vue').default);

Vue.component('leave-policies', require('./components/LeavePolicies.vue').default);
Vue.component('leave-types', require('./components/LeaveTypes.vue').default);


Vue.component('holidays', require('./components/Holidays.vue').default); // far new 10th aug 2021
Vue.component('employees-attendance-import', require('./components/EmployeesAttendanceImport.vue').default); // far new 10th aug 2021
Vue.component('leaves', require('./components/Leaves.vue').default); // new 12th aug 2021
Vue.component('employee-leave-details', require('./components/EmployeeLeaveDetails.vue').default); // new 12th aug 2021

Vue.component('employees-attendance', require('./components/EmployeesAttendance.vue').default); // new 12th aug 2021
Vue.component('worked-offsite', require('./components/WorkedOffsite.vue').default); // new 14th oct 2021
*/

/* Vue.component('apply-leave', require('./components/front/ApplyLeave.vue').default);  // fars new 25th june 2021

Vue.component('employee-front', require('./components/front/EmployeeFront').default); // fars new 4th may 2021
Vue.component('employee-dashboard', require('./components/front/EmployeeDashboard').default); // fars new 4th june 2021
Vue.component('employee-info', require('./components/front/EmployeeInfo.vue').default); // fars new 4th june 2021 */
Vue.component('subordinate-list', require('./components/SubordinateList').default); // fars new 13th may 2021
Vue.component('subordinate', require('./components/Subordinate').default); // fars new 13th may 2021

// Vue.component('leaveattendances-dashboard-front', require('./components/front/LeaveAttendanceDashboard.vue').default); 
/*** Leave Attendance Report Section Starts Here */
Vue.component('leave-report', require('./components/LeaveReport.vue').default);
Vue.component('attendance-summary-report', require('./components/AttendanceSummaryReport.vue').default);
Vue.component('monthly-attendance-report', require('./components/MonthlyAttendanceReport.vue').default);
Vue.component('leave-request-report', require('./components/LeaveRequestReport.vue').default);


/* Vue.component('leaves-front', require('./components/front/Leaves.vue').default); //Nahid
Vue.component('punch-in-or-out-front', require('./components/front/PunchInOrOut.vue').default); //Nahid
Vue.component('attendance-calender-front', require('./components/front/AttendanceCalender.vue').default); //Nahid
Vue.component('recent-leave-request-front', require('./components/front/RecentLeaveRequest.vue').default); //Nahid
Vue.component('leave-balance-front', require('./components/front/LeaveBalance.vue').default); //Nahid
Vue.component('activity-log-front', require('./components/front/ActivityLog.vue').default); //Nahid */

Vue.component('common-list-leave-report', require('./components/CommonListLeaveReport.vue').default);

Vue.component('filter-list-leave', require('./components/FilterListLeave.vue').default);

Vue.component('leaves-list-applied', require('./components/LeavesListApplied.vue').default); //ALI
Vue.component('leaves-list-approved', require('./components/LeavesListApproved.vue').default); //ALI
Vue.component('leaves-list-declined', require('./components/LeavesListDeclined.vue').default); //ALI

/* Vue.component('leaves-list-applied-front', require('./components/front/LeavesListApplied.vue').default); //ALI
Vue.component('leaves-list-approved-front', require('./components/front/LeavesListApproved.vue').default); //ALI
Vue.component('leaves-list-declined-front', require('./components/front/LeavesListDeclined.vue').default); //ALI */
Vue.component('leave-upload', require('./components/LeaveUpload.vue').default);// 11 March 2022

Vue.component('leave-attendence-report', require('./components/LeaveAttendenceReport.vue').default); // 27 July 2022
/*********************************************** */
Vue.component('leave-attendance-general', require('./components/LeaveAttendanceGeneral.vue').default); // new 15th aug 2022
Vue.component('leaves-past-data', require('./components/LeavesPastData.vue').default); // new 3rd aug 2022
Vue.component('carrying-data', require('./components/CarryingData.vue').default); // new 3rd aug 2022

Vue.component('government-holidays', require('./components/GovernmentHolidays.vue').default);

Vue.component('leaveattendances-dashboard', require('./components/LeaveAttendanceDashboard.vue').default);

Vue.component('leave-settings', require('./components/LeaveSettings.vue').default);
Vue.component('employee-leave-settings', require('./components/EmployeeLeaveAttendance.vue').default);
Vue.component('attendance-devices', require('./components/AttendanceDevices.vue').default);

Vue.component('employee-leave-attendance-wrapper', require('./components/EmployeeLeaveAttendanceWrapper.vue').default);
/* Vue.component('subordinate-leave-attendance-wrapper', require('./components/front/SubordinateLeaveAttendanceWrapper.vue').default);
Vue.component('all-employee-leave-attendance-wrapper', require('./components/front/AllEmployeeLeaveAttendanceWrapper.vue').default); */
Vue.component('employee-leave', require('./components/EmployeeLeave.vue').default);

Vue.component('leave-policies', require('./components/LeavePolicies.vue').default);
Vue.component('leave-types', require('./components/LeaveTypes.vue').default);


Vue.component('holidays', require('./components/Holidays.vue').default); // far new 10th aug 2021

Vue.component('holidays-managed-by-system-user', require('./components/HolidaysManagedBySystemUser.vue').default); // new 4th april 2022

Vue.component('employees-attendance-import', require('./components/EmployeesAttendanceImport.vue').default); // far new 10th aug 2021
Vue.component('leaves', require('./components/Leaves.vue').default); // new 12th aug 2021
// Vue.component('all-leaves-front', require('./components/front/AllLeaves.vue').default); // new 12th aug 2021
Vue.component('employee-leave-details', require('./components/EmployeeLeaveDetails.vue').default); // new 12th aug 2021

Vue.component('employees-attendance', require('./components/EmployeesAttendance.vue').default); // new 12th aug 2021
// Vue.component('employees-attendance-front', require('./components/front/EmployeesAttendance.vue').default); // new 12th aug 2021 
Vue.component('worked-offsite', require('./components/WorkedOffsite.vue').default); // new 14th oct 2021


Vue.component('custom-attribute', require('./components/CustomAttribute.vue').default);
Vue.component('employee-custom-attribute', require('./components/EmployeeCustomAttribute.vue').default);
// Vue.component('employee-custom-attribute-front', require('./components/front/EmployeeCustomAttribute.vue').default); 

Vue.component('employee-change-password', require('./components/front/EmployeeChangePassword.vue').default);

Vue.component('agent-list-menu', require('./components/AgentListMenu.vue').default);
Vue.component('company-list-menu', require('./components/CompanyListMenu.vue').default);

Vue.component('employees-contract-import', require('./components/EmployeesContractImport.vue').default);

/* Vue.component('employee-register', require('./components/front/EmployeeRegister.vue').default); // new 8th june 2021
Vue.component('employee-verify', require('./components/front/EmployeeVerify.vue').default); // new 8th june 2021

Vue.component('forget-password', require('./components/front/ForgetPassword.vue').default);

Vue.component('password-reset', require('./components/front/PasswordReset.vue').default); // new 6th july 2021 */


Vue.component('regulatory-filing', require('./components/RegulatoryFiling.vue').default); // new 13th aug 2021
Vue.component('statement-of-deduct-data', require('./components/StatementOfDeductData.vue').default); // new 13th aug 2021

Vue.component('company-settings', require('./components/CompanySettings.vue').default);
Vue.component('currency-settings', require('./components/CurrencySettings.vue').default); //currency settings

// kpi report code start
Vue.component('kpi-reports', require('./components/KpiReportings.vue').default);
// kpi report code start

// loan advance notification settings start
Vue.component('loan-advance-notification-settings', require('./components/LoanAdvanceNotificationSettings.vue').default);
// loan advance notification settings end

/** Document Section Starts Here */
Vue.component('hr-policy-handbook', require('./components/HRPolicyHandbook.vue').default);
Vue.component('hr-policy-handbook-by-department', require('./components/HRPolicyHandbookByDepartment.vue').default);

Vue.component('personal-documents', require('./components/PersonalDocuments.vue').default);

Vue.component('employment-documents', require('./components/EmploymentDocuments.vue').default);

Vue.component('tax-documents', require('./components/TaxDocuments.vue').default);

Vue.component('other-documents', require('./components/OtherDocuments.vue').default);

Vue.component('personal-tax-return-filing-ack', require('./components/PersonalTaxReturnFilingAcknowledgement.vue').default);

/** Document Section Ends Here */


/*[DEV: CST]*/
Vue.component('contract-form', require('./components/ContractForm.vue').default);
// Vue.component('employee-contract-form', require('./components/front/ContractForm.vue').default);
Vue.component('Employeepayslipdetails', require('./components/EmployeePayslipDetails.vue').default);
Vue.component('other-documents', require('./components/OtherDocuments.vue').default);

Vue.component(
  'passport-clients',  require('./components/passport/Clients.vue').default
);
Vue.component(
  'passport-authorized-clients',  require('./components/passport/AuthorizedClients.vue').default
);
Vue.component(
  'passport-personal-access-tokens',  require('./components/passport/PersonalAccessTokens.vue').default
);

Vue.component('company-taxsettings', require('./components/CompanyTaxSettings.vue').default); 

Vue.component('contract-wizard', require('./components/ContractWizard.vue').default);
Vue.component('leaver-wizard', require('./components/LeaverWizard.vue').default);
Vue.component('contract-payroll-wizard', require('./components/ContractPayrollWizard.vue').default);
Vue.component('incomplete-payruns', require('./components/IncompletePayruns.vue').default);

Vue.component('contract-view', require('./components/ContractView.vue').default);
// Vue.component('employee-contract-view', require('./components/front/ContractView.vue').default);
Vue.component('company-module-access', require('./components/CompanyModuleAccess.vue').default); // ALI 09-02-2024

/***** DEV:: Uzzal */

Vue.component('payroll-wizerd', require('./components/PayrollWizard.vue').default);


/***** DEV:: Uzzal */

//============= Payroll Vue files added by Uzzal =========================/
Vue.component('payslip', require('./components/Payslip.vue').default);
Vue.component('payslipdetail', require('./components/Payslipdetail.vue').default);
Vue.component('taxcarddetail', require('./components/Taxcard.vue').default);
Vue.component('payslips', require('./components/Payslips.vue').default);
Vue.component('payrun-payslips', require('./components/Payrunpayslips.vue').default);
Vue.component('payruns', require('./components/Payruns.vue').default);
Vue.component('newpayrun', require('./components/Newpayrun.vue').default);
Vue.component('payrunsapproved', require('./components/Payrunsapproved.vue').default);
Vue.component('payrunspaid', require('./components/Payrunspaid.vue').default);
Vue.component('payslipdetailpopup', require('./components/Payslipdetailpopup.vue').default);
Vue.component('tax-cards', require('./components/Taxcards.vue').default);
// Vue.component('employee-tax-cards', require('./components/front/Taxcards.vue').default);
Vue.component('headytd', require('./components/HeadYtd.vue').default);
Vue.component('headytdtotal', require('./components/HeadYtdTotal.vue').default);
Vue.component('headprojectedtotal', require('./components/HeadProjectedTotal.vue').default);
Vue.component('headexemptedtotal', require('./components/HeadExemptedTotal.vue').default);
Vue.component('headtaxabletotal', require('./components/HeadTaxableTotal.vue').default);
Vue.component('headprojected', require('./components/HeadProjected.vue').default);
Vue.component('taxcarddetails', require('./components/Taxcarddetails.vue').default);
Vue.component('taxcarddetailsnew', require('./components/TaxcarddetailsNew.vue').default);  // Sohel new finance bill law 17 July 2023
// Vue.component('taxcarddetailsnew-front', require('./components/front/TaxcarddetailsNew.vue').default);  // Sohel new finance bill law 13 July 2023
Vue.component('employeepayslips', require('./components/EmployeePayslips.vue').default);
// Vue.component('employeepayslips-front', require('./components/front/EmployeePayslips.vue').default);
// Vue.component('employeepfslips-front', require('./components/front/EmployeePFslips.vue').default);
Vue.component('inwords', require('./components/Inwords.vue').default);
Vue.component('headprojectedexemp', require('./components/HeadProjectedExemp.vue').default);
Vue.component('headprojectedtaxable', require('./components/HeadProjectedTaxable.vue').default);
// Vue.component('all-pf-contributions', require('./components/AllPFContributions.vue').default);
// Vue.component('pf-contributions', require('./components/PfContributions.vue').default);
// // Vue.component('employee-pf-contributions', require('./components/front/PfContributions.vue').default);
// Vue.component('pf-statement-download-form', require('./components/PfStatementDownloadForm.vue').default);
// Vue.component('pf-loan-statement-download-form', require('./components/PfLoanStatementDownloadForm.vue').default);
// Vue.component('employee-pf-statement', require('./components/EmployeePFStatement.vue').default);
// Vue.component('employee-pf-statement-front', require('./components/front/EmployeePFStatementFront.vue').default);

Vue.component('taxrules', require('./components/Taxrules.vue').default);
Vue.component('taxrules', require('./components/Taxrules.vue').default);
Vue.component('minimumtax', require('./components/Minimumtax.vue').default);
Vue.component('newpayslip', require('./components/NewPayslip.vue').default);

Vue.component('payrun-wizard', require('./components/PayrunWizard.vue').default);
//================ Payroll Vue files listing ends ================/

//=============Challan Vue Files Added By Uzzal==================/
Vue.component('allchallans', require('./components/Challans.vue').default);
Vue.component('employeechallans', require('./components/EmployeeChallans.vue').default);
//=============Challan files listing ends========================/


//=============Vue Files Added By Sohel==================/
// Vue.component('taxcarddetails-front', require('./components/front/Taxcarddetails.vue').default);
// Vue.component('EmployeepayslipdetailsFront', require('./components/front/EmployeePayslipDetails.vue').default);
Vue.component('ComplianceSummary', require('./components/ComplianceSummary.vue').default);
Vue.component('payroll-reporting', require('./components/PayrollReporting.vue').default);
Vue.component('monthly-payroll-report', require('./components/MonthlyPayrollReport.vue').default);
Vue.component('comprehensive-payroll-report', require('./components/ComprehensivePayrollReport.vue').default);
Vue.component('tds-report', require('./components/TdsReport.vue').default);
Vue.component('tax-computation-sheet', require('./components/TaxComputationSheet.vue').default);
Vue.component('yearly-payroll-report', require('./components/YearlyPayrollReport.vue').default);
Vue.component('variance-report', require('./components/VarianceReport.vue').default);

/* Vue.component('account-employees-front', require('./components/front/AccountEmployees').default); // new
Vue.component('employee-leave-details-front', require('./components/front/EmployeeLeaveDetails.vue').default);  // new
Vue.component('contract-wizard-front', require('./components/front/ContractWizard.vue').default);
Vue.component('contract-view-front', require('./components/front/ContractView.vue').default);
Vue.component('employee-leave-attendance-wrapper-front', require('./components/front/EmployeeLeaveAttendanceWrapper.vue').default);  // new or modified */
Vue.component('other-settings', require('./components/OtherSettings.vue').default); //Nahid

Vue.component('employee-spouse-info', require('./components/EmployeeSpouseInfo.vue').default); // new 17th nov 2021
Vue.component('employee-child-info', require('./components/EmployeeChildInfo.vue').default); // new 17th nov 2021

// Vue.component('employee-spouse-info-front', require('./components/front/EmployeeSpouseInfo.vue').default); // for ESS portal
// Vue.component('employee-child-info-front', require('./components/front/EmployeeChildInfo.vue').default); // for ESS portal

Vue.component('leave-encashment-report', require('./components/LeaveEncashmentReport.vue').default);
Vue.component('agent-billing', require('./components/AgentBilling.vue').default);
Vue.component('agent-billing-annual', require('./components/AgentBillingAnnual.vue').default);

//=============Loan and Advance Vue Files Added By ALI==================/
Vue.component('all-loans', require('./components/LoanDashboard.vue').default);// 16th August 2021 
Vue.component('loan-wizard', require('./components/LoanWizard.vue').default);// 16th August 2021 
Vue.component('employee-loan-list', require('./components/EmployeeLoanInfo.vue').default);// 16th August 2021 
Vue.component('loan-application-wizard', require('./components/LoanApplicationWizard.vue').default);// 23rd August 2021 
Vue.component('loan-application-list', require('./components/LoanApplicationList.vue').default);// 23rd August 2021
Vue.component('loan-transaction-wizard', require('./components/LoanTransactionWizard.vue').default);// 23rd August 2021
Vue.component('loan-form', require('./components/LoanAdvanceForm.vue').default);// 23rd August 2021
Vue.component('loan-public-info', require('./components/LoanPublicInfo.vue').default);// 19 Sept 2021
Vue.component('loan-search-employee', require('./components/LoanSearchEmployee.vue').default);// 5 Oct 2021
// Vue.component('employee-loan-list-front', require('./components/front/LoanEmployeeLoanFront.vue').default);// 8th FEB 2022 
// Vue.component('loan-form-front', require('./components/front/LoanFormFront.vue').default);// 8th FEB 2022


Vue.component('loan-reporting', require('./components/LoanReporting.vue').default); // 11 FEB 2022
Vue.component('loan-monthly-report', require('./components/LoanMonthlyReport.vue').default); // 11 FEB 2022
Vue.component('loan-schedule-report', require('./components/LoanScheduleReport.vue').default); // 11 FEB 2022

Vue.component('emplyee-access-control-settings', require('./components/EmployeeAccessControlSettings.vue').default); // ALI 6-6-2022
Vue.component('payslip-and-taxcard-design', require('./components/PayslipAndTaxcardDesign.vue').default); // ALI 10-11-2022
Vue.component('payslip-design-preview', require('./components/PayslipDesignPreview.vue').default)



//=============Loan and Advance Vue Files Added By ALI ends========================//

// ============ Device Mapping ===============//
Vue.component('device-signup', require('./components/DeviceSignup.vue').default); // 9 Nov 2021 
Vue.component('device-mapping-import', require('./components/DeviceMappingImport.vue').default); // 9 Nov 2021 
// ============ Device Mapping End ===============//



Vue.component('lock-template', require('./components/LockTemplate.vue').default);// 11 MAY 2022

Vue.component('common-list', require('./components/DemoList.vue').default);// 5 Oct 2021
Vue.component('filter-list', require('./components/FilterList.vue').default);// 5 Oct 2021
Vue.component('employee-info-list', require('./components/EmployeeInfoList.vue').default);// 5 Oct 2021
Vue.component('employee-filter', require('./components/EmployeeFilter.vue').default);// 5 Oct 2021 
Vue.component('general-list', require('./components/GeneralList.vue').default);// 21 June 2022
Vue.component('general-filter-list', require('./components/GeneralFilterList.vue').default);// 21 June 2022



//==================== charts compnents (aboni) starts =========// 18 nov 21

Vue.component('doughnut-chart', require('./components/DoughnutChart.vue').default);
Vue.component('bar-chart', require('./components/BarChart.vue').default);
Vue.component('line-chart', require('./components/LineChart.vue').default);
Vue.component('radar-chart', require('./components/RadarChart.vue').default);
Vue.component('polar-charts', require('./components/PolarChart.vue').default);



//=========activity log=============================/
Vue.component('activitylog', require('./components/ActivityLog.vue').default);
Vue.component('email-log', require('./components/EmailLog.vue').default);
Vue.component('activitysystemlog', require('./components/ActivitySystemLog.vue').default);
Vue.component('activityattendancelog', require('./components/ActivityAttendanceLog.vue').default); // Ali  
//==================== charts compnents (aboni) ends =========// 18 nov 21 

Vue.component('corehr-index', require('./components/CoreHRIndex.vue').default);
Vue.component('corehr-certificates', require('./components/CoreHRCertificates.vue').default);
Vue.component('all-templates', require('./components/AllTemplates.vue').default);

Vue.component('company-compliance-summary', require('./components/CompanyComplianceSummary.vue').default); // new 23rd jan 2022

Vue.component('employee-fields', require('./components/EmployeeFields.vue').default);// 14 Oct 2021
Vue.component('pass-confirm-form', require('./components/PassConfirmForm.vue').default); // new 23rd jan 2022

Vue.component('payroll-run-status', require('./components/PayrollRunStatus.vue').default); // new 8 Apr 2022
Vue.component('dashboard-leave-card', require('./components/DashboardLeaveCard.vue').default); // new 8 Apr 2022

 
Vue.component('maintenance', require('./components/Maintenance.vue').default);

Vue.component('terms', require('./components/Terms.vue').default);
/*** ACL Starts Here */
Vue.component('all-resource', require('./components/AllResource.vue').default);// 7th june 2022
Vue.component('all-roles', require('./components/AllRoles.vue').default);// 8th feb 2022
Vue.component('roles-agent', require('./components/RolesAgent.vue').default);// 8th july 2022
Vue.component('roles-company', require('./components/RolesCompany.vue').default);// 8th feb 2022
Vue.component('role-resource', require('./components/RoleResource.vue').default);// 14th april 2022

Vue.component('new-resource', require('./components/NewResource.vue').default);

/*** ACL Ends Here */

Vue.component('employees-variable-data-import', require('./components/EmployeesVariableDataImport.vue').default);

Vue.component('all-schedule', require('./components/AllSchedule.vue').default);

/** Accounting JV starts [shatabdi] **/
Vue.component('cost-center', require('./components/CostCenter.vue').default); //cost center
Vue.component('accountingjv-report', require('./components/AccountingJVReport.vue').default); //cost center
Vue.component('jv-report', require('./components/JVReport.vue').default); //cost center
Vue.component('detail-report', require('./components/DetailReport.vue').default); //cost center
Vue.component('employee-cost-center', require('./components/EmployeeCostCenter.vue').default); //employee cost center

/** Accounting JV ends**/

Vue.component('checkin-on-map', require('./components/CheckinOnMap.vue').default);

Vue.component('countdown-timer', require('./components/Countdown.vue').default); //Sohel 01-07-2024  

Vue.component('email-templates', require('./components/EmailTemplates.vue').default); // email templates

// Afrin: NOC updates starts here
Vue.component('employee-noc-documents-front', require('./components/front/documents/EmployeeNocDocuments.vue').default); // added by afrin 

Vue.component('employee-noc-documents', require('./components/EmployeeNocDocuments.vue').default); // added by afrin 
Vue.component('bulk-noc-documents', require('./components/BulkNocDocuments.vue').default); // added by afrin 

// Afrin: NOC updates ends here
Vue.component('ait-breakdown', require('./components/DashboardAitBreakdown.vue').default); // Afrin : added 7-29-26
Vue.component('investment-breakdown', require('./components/DashboardInvestmentBreakdown.vue').default); // Afrin : added 7-29-26

// ESS components starts
Vue.component('employee-front', require('./components/front/EmployeeFront').default); // fars new 4th may 2021
Vue.component('employee-dashboard', require('./components/front/EmployeeDashboard').default); // fars new 4th june 2021
Vue.component('employee-register', require('./components/front/EmployeeRegister.vue').default); // new 8th june 2021
Vue.component('employee-verify', require('./components/front/EmployeeVerify.vue').default); // new 8th june 2021
Vue.component('forget-password', require('./components/front/ForgetPassword.vue').default);
Vue.component('password-reset', require('./components/front/PasswordReset.vue').default); // new 6th july 2021
Vue.component('employee-custom-attribute-front', require('./components/front/EmployeeCustomAttribute.vue').default); 

/***Document ESS ****/
Vue.component('hr-policy-handbook-by-department-front', require('./components/front/documents/HRPolicyHandbookByDepartment.vue').default);
Vue.component('personal-documents-front', require('./components/front/documents/PersonalDocuments.vue').default);
Vue.component('employment-documents-front', require('./components/front/documents/EmploymentDocuments.vue').default);
Vue.component('tax-documents-front', require('./components/front/documents/TaxDocuments.vue').default);
Vue.component('other-documents-front', require('./components/front/documents/OtherDocuments.vue').default);
Vue.component('personal-tax-return-filing-ack-front', require('./components/front/documents/PersonalTaxReturnFilingAcknowledgement.vue').default);
/***Document ESS END ****/

Vue.component('employee-contract-form', require('./components/front/ContractForm.vue').default);
Vue.component('employee-contract-view', require('./components/front/ContractView.vue').default);


Vue.component('employee-tax-cards', require('./components/front/Taxcards.vue').default);
Vue.component('employeepayslips-front', require('./components/front/EmployeePayslips.vue').default);




//=============Vue Files Added By Sohel==================//
Vue.component('taxcarddetails-front', require('./components/front/payroll/Taxcarddetails.vue').default);
Vue.component('taxcarddetailsnew-front', require('./components/front/payroll/TaxcarddetailsNew.vue').default);  // Sohel new finance bill law 13 July 2023
Vue.component('EmployeepayslipdetailsFront', require('./components/front/payroll/EmployeePayslipDetails.vue').default);
Vue.component('account-employees-front', require('./components/front/AccountEmployees').default); // new
Vue.component('contract-wizard-front', require('./components/front/ContractWizard.vue').default);
Vue.component('contract-view-front', require('./components/front/ContractView.vue').default);
Vue.component('employee-spouse-info-front', require('./components/front/EmployeeSpouseInfo.vue').default); // for ESS portal
Vue.component('employee-child-info-front', require('./components/front/EmployeeChildInfo.vue').default); // for ESS portal

 

//=============Vue Files Added By Ali==================//



/// Loan Advance ///
Vue.component('employee-loan-list-front', require('./components/front/loan-advance/LoanEmployeeLoanFront.vue').default);// 8th FEB 2022 
Vue.component('loan-form-front', require('./components/front/loan-advance/LoanFormFront.vue').default);// 8th FEB 2022
Vue.component('loan-transaction-wizard-front', require('./components/front/loan-advance/LoanTransactionWizard.vue').default);// 23rd August 2021
Vue.component('loan-public-info-front', require('./components/front/loan-advance/LoanPublicInfo.vue').default);// 19 Sept 2021



Vue.component('attendance-calender-front', require('./components/front/leaveattendance/AttendanceCalender.vue').default); //Nahid
Vue.component('recent-leave-request-front', require('./components/front/leaveattendance/RecentLeaveRequest.vue').default); //Nahid
Vue.component('leaveattendances-dashboard-front', require('./components/front/leaveattendance/LeaveAttendanceDashboard.vue').default); 
Vue.component('leaves-front', require('./components/front/leaveattendance/Leaves.vue').default); //Nahid
Vue.component('punch-in-or-out-front', require('./components/front/leaveattendance/PunchInOrOut.vue').default); //Nahid
Vue.component('leave-balance-front', require('./components/front/leaveattendance/LeaveBalance.vue').default); //Nahid
Vue.component('activity-log-front', require('./components/front/leaveattendance/ActivityLog.vue').default); //Nahid
Vue.component('leaves-list-applied-front', require('./components/front/leaveattendance/LeavesListApplied.vue').default); //ALI
Vue.component('leaves-list-approved-front', require('./components/front/leaveattendance/LeavesListApproved.vue').default); //ALI
Vue.component('leaves-list-declined-front', require('./components/front/leaveattendance/LeavesListDeclined.vue').default); //ALI
Vue.component('all-employee-leave-attendance-wrapper-front', require('./components/front/leaveattendance/AllEmployeeLeaveAttendanceWrapper.vue').default);
Vue.component('all-leaves-front', require('./components/front/leaveattendance/AllLeaves.vue').default); // new 12th aug 2021

Vue.component('employees-attendance-front', require('./components/front/leaveattendance/EmployeesAttendance.vue').default); // new 12th aug 2021 
Vue.component('employee-leave-attendance-wrapper-front', require('./components/front/leaveattendance/EmployeeLeaveAttendanceWrapper.vue').default);  // new or modified
Vue.component('employee-leave-details-front', require('./components/front/leaveattendance/EmployeeLeaveDetails.vue').default);  // new
Vue.component('inwords-front', require('./components/front/Inwords.vue').default);


/// ESS File ENDS ///
Vue.component('double-scroll-wrapper', require('./components/DoubleScrollWrapper.vue').default) // Rejwan: 18-05-2026 pf_unified

// Abdullah Added componenet for the dashboard
Vue.component('major-payroll-movement', require('./components/DashboardMajorPayrollMovement.vue').default);  //Abd 04/26
Vue.component('payroll-quick-stat', require('./components/DashboardPayrollQuickStat.vue').default);  //Abd 04/26
Vue.component('payroll-breakup', require('./components/DashboardPayrollBreakup.vue').default);  //Abd 04/26
Vue.component('payroll-run-status', require('./components/PayrollRunStatus.vue').default); // Abd 04/26
Vue.component('company-approved-holidays', require('./components/CompanyApprovedHolidays.vue').default);  //Abd 04/26
Vue.component('joiner-leaver-graph', require('./components/DashboardJoinerLeaverGraph.vue').default); //Abd 04/26
// Abdullah Added componenet for the dashboard

Vue.component('file-component', require('./components/FileComponent.vue').default);// Rejwan: gf_unified

// tax reducers approval settings start
Vue.component('tax-reducers-approval-settings', require('./components/TaxReducersApprovalSettings.vue').default);
// tax reducers approval settings end
Vue.component('pending-investment', require('./components/PendingInvestment.vue').default); // Afrin 
Vue.component('pending-ait', require('./components/PendingAit.vue').default); // Afrin 

const requireComponent = require.context('../../app/Modules', true, /\/Components\/[^/]+\.vue$/);
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = fileName.split('/').pop().replace(/\.\w+$/, '');
  const moduleName = fileName.split('/')[1]; 
  const fullComponentName = `${moduleName}${componentName}`;  
  // alert(fullComponentName);
  Vue.component(fullComponentName, componentConfig.default || componentConfig);
});
 
window.Fire = new Vue();
Vue.mixin({
  methods: {
    
    checkNet: function () 
    {
      var ifConnected = window.navigator.onLine;
      if (ifConnected) {
          return true;
      } 
      else {
        this.$bvToast.toast('You are offline.', {
              title: `Error`,
              variant: 'danger',
              solid: true,
              toaster: 'b-toaster-bottom-left'
          }); 

          return false;
      }
    },
    companyNumberSettings : function()
    { 
      //axios.get('https://secure.atlhr.com/get/fiscalyear/list').then(function(response)
      axios.get(this.$api_url+'/get/number-settings').then(function(response)
      {   
        //Vue.prototype.$fiscal_years = response.data;
        Vue.prototype.$atl_company_number_format = response.data;
        
      }.bind(this));
    },
    listFiscalYears : function()
    { 
      //axios.get('https://secure.atlhr.com/get/fiscalyear/list').then(function(response)
      axios.get(this.$api_url+'/get/fiscalyear/list').then(function(response)
      {   
        Vue.prototype.$fiscal_years = response.data;
        let fy = [];

        let years = [];

        var year = [];

        let j = 0;
        for(let i=0 ; i < response.data.length ; i++)
        {
          year = response.data[i].split('-');
          years[j] = year[1];
          j = j + 1;

          if(i == response.data.length-1)
          {
            years[j] = year[0];
          }

          

        }

        Vue.prototype.$years = years;

        for(let i=0 ; i < response.data.length ; i++)
        {
          fy[i] = {value: response.data[i] , text: response.data[i] };

       

        }

        Vue.prototype.$fiscal_year_options = fy;

      }.bind(this));
    },
    checkPastDate : function(d)
    {                   
        return new Date() > new Date(d);
    }, 
    checkFileType(event, refKey, allowedFileTypes, opts = {})
    {

      // Options (tweak as needed)
      const {
        maxFiles = 10,            // max files per selection
        maxFileSizeMB = 50,       // generic per-file cap
        zipMaxMB = 50             // stricter or separate cap for .zip
      } = opts;

      const input = event?.target;
      const files = Array.from(input?.files || []);
      const allowList = (allowedFileTypes || []).map(t => t.toLowerCase()); // e.g. ['.pdf', '.jpg', '.zip']

      // Helper: reset control safely across browsers/components
      const reset = () => {
        if (this.$refs?.[refKey]?.reset) this.$refs[refKey].reset();
        if (input) input.value = '';
      };

      // Basic count guard
      if (files.length > maxFiles) {
        reset();
        alert(`Too many files. Max allowed: ${maxFiles}.`);
        return false;
      }

      // Validate all files
      for (const file of files) {
        const rawName = file?.name || '';
        const baseName = rawName.split(/[/\\]/).pop(); // strip any fake paths

        // 1) Block path traversal & any slash/backslash
        const forbidden = ['../', '..\\', '/..', '\\..', '/', '\\'];
        if (forbidden.some(s => rawName.includes(s))) {
            reset();
            // alert('Invalid filename: path segments are not allowed.');
            this.$bvToast.toast('Invalid filename: path segments are not allowed.', {
                title: `Upload Failed`,
                variant: 'danger',
                solid: true
            });
            return false;
        }

        // 2) No leading or trailing dot
        if (baseName.startsWith('.') || baseName.endsWith('.')) {
            reset();
            this.$bvToast.toast('Invalid filename: no leading or trailing dots allowed.', {
                title: `Upload Failed`,
                variant: 'danger',
                solid: true
            });
          return false;
        }

        // 3) Exactly one dot in the basename (prevents multiple extensions)
        const dotCount = (baseName.match(/\./g) || []).length;
        if (dotCount !== 1) {
          reset();
            this.$bvToast.toast('Invalid filename: use exactly one dot before the extension (e.g., "document.pdf").', {
                title: `Upload Failed`,
                variant: 'danger',
                solid: true
            });
          return false;
        }

        // 4) Extension allow-list
        const ext = '.' + baseName.split('.').pop().toLowerCase();
        if (!allowList.includes(ext)) {
            reset();
            this.$bvToast.toast(`Invalid file type "${ext}". Allowed: ${allowList.join(', ')}`, {
                title: `Upload Failed`,
                variant: 'danger',
                solid: true
            });
          return false;
        }

        // 5) Size guards (front-end only; zip-bomb detection is server-side)
        const sizeMB = file.size / (1024 * 1024);
        if (ext === '.zip') {
          if (sizeMB > zipMaxMB) {
            reset();
            this.$bvToast.toast(`ZIP too large (${sizeMB.toFixed(2)} MB). Max allowed: ${zipMaxMB} MB.`, {
                title: `Upload Failed`,
                variant: 'danger',
                solid: true
            });

            return false;
          }
          // Optional: remind user we’ll do deep checks on server
          // console.info('ZIP file will undergo server-side decompression safety checks.');
        } else {
          if (sizeMB > maxFileSizeMB) {
            reset();
            this.$bvToast.toast(`File too large (${sizeMB.toFixed(2)} MB). Max allowed: ${maxFileSizeMB} MB.`, {
                title: `Upload Failed`,
                variant: 'danger',
                solid: true
            });
            return false;
          }
        }
      }

      return true; // all good
    },
    download_file(fileURL) 
    {
        if(!this.checkNet()) return false;
        
        var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
        if (!window.ActiveXObject) {
            var save = document.createElement('a');
            save.href = fileURL;
            save.target = '_blank';
            //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
            save.download = fileName || filename;
            if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                    document.location = save.href;
                }else{
                    var evt = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    save.dispatchEvent(evt);
                    (window.URL || window.webkitURL).revokeObjectURL(save.href);
                }    
        }
        else if ( !! window.ActiveXObject && document.execCommand)     {
            var _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName || fileURL)
            _window.close();
        }
    },
    downloadFileContent(filepath)
    {
      
      const config = {
            headers: { 'Content-Type': 'application/json; charset=utf-8', },
            responseType: 'blob',
          }
          let formData = new FormData();           
          // formData.append('tkn', crypt.encrypt(filepath)); // added by Faroque - Note: you can remove the encryption from here and then need to remove encryption from controller end too
          formData.append('tkn', filepath);

          axios.post(this.$api_url + '/ghostme', formData, config)
              .then(function (response)
              {                
                  this.showoverlay = false;                                                  
                  if(response.data.type =='application/json'){
                      let file = new Blob([response.data], {type: 'application/json'}); /* if you use different error message just change the name instead of  'error_msg' */
                      const cast = Promise.resolve(file.text());
                      cast.then((value) => {
                        let err_obj = JSON.parse(`${value}`);
                        this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});  
                      });
                    }else{
                      // this.download_file_content(response);
                      const contentDisposition = response.headers['content-disposition'];
			let fileName = 'default-filename.extension'; // Fallback filename

			if (contentDisposition && contentDisposition.includes('filename=')) {
			    // Extract filename from Content-Disposition header
			    fileName = contentDisposition
				.split(';')
				.find(part => part.trim().startsWith('filename='))
				.split('=')[1]
				.trim();

			    // Remove surrounding quotes, if any
			    fileName = fileName.replace(/^"|"$/g, '');
			}

                      
                      // Create a blob from the response data
                      const blob = new Blob([response.data], { type: response.headers['content-type'] });

                      // Create a blob URL
                      const url = window.URL.createObjectURL(blob);
                      
                      const link = document.createElement('a');
		          link.href = url;
		          link.download = fileName;
		          document.body.appendChild(link);
		          link.click();
		          document.body.removeChild(link);
                    }
                  
              }.bind(this))
              .catch(function (error)
              {
                  currentObj.errormsg = error.response.data.errors;
              });


    },
    global_download_file_content(response){
                const contentDisposition = response.headers['content-disposition'];
                
                if(!contentDisposition)
                return;
                
                const fileName = contentDisposition
                    ? contentDisposition.split(';')[1].trim().split('=')[1].replace(/^["']|["']$/g, '')
                    : 'your-file-name.extension'; // Fallback to a default name if not provided

                // Create a blob from the response data
                const blob = new Blob([response.data], { type: response.headers['content-type'] });

                // Create a link element and trigger a download
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); 
    },
    // Start: Rejwan: pf_unified
    downloadBlobResponse(axiosPromise, loaderKey = 'loader', onJsonError = null) {
        axiosPromise
      .then(function (response) {
          if (loaderKey && this[loaderKey] !== undefined) {
              this[loaderKey] = false;
          }

          if (response.data.type === 'application/json') {
            const reader = new FileReader();
            reader.onload = function () {
                try {
                    const data = JSON.parse(reader.result);

                    if (typeof onJsonError === 'function') {
                        onJsonError(data); // ✅ always call, let the callback decide what to do
                    } else if (data.errors || data.error) {
                        this.$bvToast.toast(data.error || 'An error occurred.', {
                            title: 'Error',
                            variant: 'danger',
                            solid: true,
                        });
                    }
                } catch (e) {
                    this.errormsg = 'Download failed.';
                }
            }.bind(this);
            reader.readAsText(response.data);
          } else {
              this.global_download_file_content(response);
          }
      }.bind(this))
      .catch(function (error) {
          if (loaderKey && this[loaderKey] !== undefined) {
              this[loaderKey] = false;
          }
          this.errormsg = 'Download failed.';
      }.bind(this));
    },

    formatMoney: function(amount){
        // var money = Number(amount); // Rejwan: 24-04-2025 2 decimal
        var money = Number(String(amount).replace(/,/g, '')); // Rejwan: 24-04-2025 2 decimal

        // if(this.$atl_company_number_format == 'no') // Rejwan: 24-04-2025 2 decimal
        if(this.$atl_company_number_format == 'no') // Rejwan: 24-04-2025 2 decimal
        {
            money = Math.round(money);
            money = money.toLocaleString();
            if(money=='NaN') // Rejwan: 24-04-2025 2 decimal
              money = amount; // Rejwan: 24-04-2025 2 decimal
        }
        else
        {

            // money = money.toLocaleString(); // Rejwan: 18-06-2025 2 decimal
            if(money=='NaN')
            money = amount;
            else{
                // Start: Rejwan: 18-06-2025 2 decimal
                // if(money.indexOf(".")<0)
                // money = money+".00";
                // if(money.length - money.lastIndexOf(".")==2)
                // money =  money+"0";
                // End: Rejwan: 18-06-2025 2 decimal
                money = money.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }

        }

        return money;
      },

      downloadDocuments: function(transaction_id, document_type = 6, movement_id=0) {
            /**
             * Document Type: 1 = Instrument, 6 = Processing, 7 = Additional T-Bill; T-Bond,
             * For additional tbill and tbond we need movement_id which is equal to transaction_id
             */
            let currentObj = this;
            let formData = new FormData();
            const config = {
                //headers: { 'content-type': 'multipart/form-data' }
            }
            formData.append('instrument_id', transaction_id);
            formData.append('document_type', document_type);
            formData.append('transaction_id', movement_id);
            axios.post(this.$api_url+'/fundinvestment/download-documents', formData)
            .then(function (response) {
                var fileURL = response.data;
                if(response.data.success == false) {
                    currentObj.$bvToast.toast(response.data.message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                } else {
                    currentObj.download_file(fileURL);
                }
            });
        },
    // End: Rejwan: pf_unified
    /*serverError: function (error)
    {
	    if(!error.response)return;
      if(!error.response.status)return;
      if(error.response.status == 500)
      {
        this.$bvToast.toast('Server error.', {
            title: `Error`,
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-bottom-left'
        }); 
        return false;
      }
      else if((error.response.status == 403))
      {
		this.$bvToast.toast('You are not authorized to access this.', {
		  title: `Error`,
		  variant: 'danger',
		  solid: true,
		  toaster: 'b-toaster-bottom-left'
	      }); 
	      return false;
      }   
          
      else if((error.response.status == 419) || (error.response.status == 401))
          location.reload();
    },*/
    
    serverError: function (error)
    {
	    if(!error.response)return;
      if(!error.response.status)return;
      if(error.response.status == 500)
      {
        this.$bvToast.toast('Something went wrong! We\'ll be back soon!', {
            title: `Something went wrong!`,
            variant: 'warning',
            solid: true,
            toaster: 'b-toaster-bottom-left'
        }); 
        return false;
      }
      else if (error.response.status === 400)
	{
	    this.$bvToast.toast(
		'The request was rejected by the server.',
		{
		    title: 'Bad Request',
		    variant: 'danger',
		    solid: true,
		    toaster: 'b-toaster-bottom-left'
		}
	    );

	    return false;
	}
      else if((error.response.status == 403))
      {
        this.$bvToast.toast('You are not authorized to access this.', {
          title: `Error`,
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-left'
            }); 
	        return false;
      }   
      else if((error.response.status == 422))
        {
          // console.log(error.response.data.message);
          
          this.$bvToast.toast(error.response.data.message, {
            title: `Error`,
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-bottom-left'
              }); 
            return false;
        }
          
      else if((error.response.status == 419) || (error.response.status == 401))
      {
        this.$bvToast.toast('Page is reloading', {
              title: 'Form Session EXpired',
              variant: 'warning',
              solid: true
          }); 


        setTimeout(function() {
                //window.location.reload()
            }, 2000);
      }    
    	else
    	{
        this.$bvToast.toast(error.response.data.message, {
            title: 'Form Session EXpired',
            variant: 'warning',
            solid: true
        }); 


        /*setTimeout(function() {
            window.location.reload()
        }, 2000);*/
      }
    },
    
    getCurrentFinancialYear : function() {
      var fiscalyear = "";
      var today = new Date();
      if ((today.getMonth() + 1) <= 6) {
        fiscalyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
      } else {
        fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
      }
      return fiscalyear
    },

    paginate(array, length, pageNumber) 
      {
          let l = parseInt(array.length);
          let m = parseInt(length);
          this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
          this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
          this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
          this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';

          if(l > 0)
          {
              this.pagination.pages = Math.ceil(l / m);
          }
          return array.slice((pageNumber - 1) * length, pageNumber * length);
      },
      resetPagination()
      {
          this.pagination.currentPage = 1;
          this.pagination.prevPage = '';
          this.pagination.nextPage = '';
      },
      setFirstPage()
      {  
          this.pagination.currentPage = 1;                
          this.length = this.temp_length;   
      },
      sortBy(key) 
      {
          this.resetPagination();
          this.sortKey = key;
          this.sortOrders[key] = this.sortOrders[key] * -1;
      },
      getIndex(array, key, value) 
      {
          return array.findIndex(i => i[key] == value)
      },
      formatPhoneNumber: function(value)
      {
        let phone_number_slice_one;
        let phone_number_slice_two;
        let phone_number_slice_three;
        let phone_number_slice_four;
        let phone_number;
        if(value){
            if(value.slice(0,2) != '88'){
                value = '88'+value;
            }
            if(value.slice(2,3) != '0'){
                value = value.slice(2);
                value = '880'+value;
            }
            phone_number_slice_one = '+'+value.slice(0,2);
            phone_number_slice_two = value.slice(2,7);
            phone_number_slice_three = value.slice(7,10);
            phone_number_slice_four = value.slice(10);
            phone_number = phone_number_slice_one+'-'+phone_number_slice_two+'-'+phone_number_slice_three+'-'+phone_number_slice_four;
        }else{
            phone_number = '';
        }
        return phone_number;
      },
      validateState(ref)
      {
          if (
              this.veeFields[ref] &&
              (this.veeFields[ref].dirty || this.veeFields[ref].validated)
          ) {
              return !this.veeErrors.has(ref);
          }
          return null;
      },
      replaceDotWithUnerscore(value){
        if(value){
            value = value.replaceAll('.','_');
            return value;
        }else{
            return '';
        }
      },

      // PAYE updates
      getFiscalYearsPaye() {
        const today = new Date();
        const month = today.getMonth() + 1; // 1-12
        const year = today.getFullYear();

        // Fiscal year starts in July
        const fiscalYearStartMonth = 7;

        // If current month is before July, fiscal year is previous year
        let currentFiscalYear = month < fiscalYearStartMonth ? year - 1 : year;

        const years = [];
        for (let i = 0; i < 3; i++) {
          const start = currentFiscalYear + i;
          const end = start + 1;
          years.push(`${start}-${end}`);
        }

        return years;
      },
      // PAYE updates
    
      // Start: Rejwan: pf_unified
      loadSiteOptions: function () {
        axios.get(this.$api_url + '/load-site-options').then(function(response) {
          const keyed = {};
          response.data.forEach(o => {
              keyed[o.opt_key] = (o.opt_value != null && o.opt_value != '') ? o.opt_value : o.opt_value_serialized;
          });
          Vue.prototype.$site_options = keyed;
          // Object.assign(Vue.prototype.$site_options, keyed);
        }.bind(this));
      },
  }
})
const app = new Vue({
    el: '#app',
    created: function() {
      
      this.loadSiteOptions(); // Start: Rejwan: 23-06-2026
      this.companyNumberSettings();
      this.listFiscalYears();
    },
    ata:{
      moment: moment
     }
});
